// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeamMemberFieldsFragment = { __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, invite_url?: string | null, is_archived: boolean, created_at: number, updated_at: number, user?: { __typename?: 'User', id: string } | null };

export type MinimalTeamMemberFieldsFragment = { __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, invite_url?: string | null, user?: { __typename?: 'User', id: string } | null };

export type TeamMemberQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TeamMemberQuery = { __typename?: 'Query', teamMember: { __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, invite_url?: string | null, is_archived: boolean, created_at: number, updated_at: number, user?: { __typename?: 'User', id: string } | null } };

export type TeamMembersQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  role?: Types.InputMaybe<Types.TeamMemberRole>;
}>;


export type TeamMembersQuery = { __typename?: 'Query', teamMembers: Array<{ __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, invite_url?: string | null, user?: { __typename?: 'User', id: string } | null }> };

export type AcceptTeamMemberInvitationMutationVariables = Types.Exact<{
  invitationId: Types.Scalars['ID']['input'];
  teamMemberId: Types.Scalars['ID']['input'];
}>;


export type AcceptTeamMemberInvitationMutation = { __typename?: 'Mutation', acceptTeamMemberInvitation: { __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, invite_url?: string | null, is_archived: boolean, created_at: number, updated_at: number, user?: { __typename?: 'User', id: string } | null } };

export type CreateTeamMemberMutationVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  data: Types.CreateTeamMemberInput;
}>;


export type CreateTeamMemberMutation = { __typename?: 'Mutation', createTeamMember: { __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, invite_url?: string | null, is_archived: boolean, created_at: number, updated_at: number, user?: { __typename?: 'User', id: string } | null } };

export type UpdateTeamMemberMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  data: Types.UpdateTeamMemberInput;
}>;


export type UpdateTeamMemberMutation = { __typename?: 'Mutation', updateTeamMember: { __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, invite_url?: string | null, is_archived: boolean, created_at: number, updated_at: number, user?: { __typename?: 'User', id: string } | null } };

export type DeleteTeamMemberMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteTeamMemberMutation = { __typename?: 'Mutation', deleteTeamMember?: any | null };

export type SendTeamMemberInviteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type SendTeamMemberInviteMutation = { __typename?: 'Mutation', sendTeamMemberInvite?: any | null };

export const TeamMemberFieldsFragmentDoc = gql`
    fragment TeamMemberFields on TeamMember {
  id
  user {
    id
  }
  name
  email
  role
  invite_url
  is_archived
  created_at
  updated_at
}
    `;
export const MinimalTeamMemberFieldsFragmentDoc = gql`
    fragment MinimalTeamMemberFields on TeamMember {
  id
  name
  email
  role
  user {
    id
  }
  invite_url
}
    `;
export const TeamMemberDocument = gql`
    query teamMember($id: ID!) {
  teamMember(id: $id) {
    ...TeamMemberFields
  }
}
    ${TeamMemberFieldsFragmentDoc}`;

/**
 * __useTeamMemberQuery__
 *
 * To run a query within a React component, call `useTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamMemberQuery(baseOptions: Apollo.QueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
      }
export function useTeamMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
        }
export type TeamMemberQueryHookResult = ReturnType<typeof useTeamMemberQuery>;
export type TeamMemberLazyQueryHookResult = ReturnType<typeof useTeamMemberLazyQuery>;
export type TeamMemberQueryResult = Apollo.QueryResult<TeamMemberQuery, TeamMemberQueryVariables>;
export const TeamMembersDocument = gql`
    query teamMembers($outfitterId: ID!, $role: TeamMemberRole) {
  teamMembers(outfitterId: $outfitterId, role: $role) {
    ...MinimalTeamMemberFields
  }
}
    ${MinimalTeamMemberFieldsFragmentDoc}`;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
      }
export function useTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersQueryResult = Apollo.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const AcceptTeamMemberInvitationDocument = gql`
    mutation acceptTeamMemberInvitation($invitationId: ID!, $teamMemberId: ID!) {
  acceptTeamMemberInvitation(
    invitationId: $invitationId
    teamMemberId: $teamMemberId
  ) {
    ...TeamMemberFields
  }
}
    ${TeamMemberFieldsFragmentDoc}`;
export type AcceptTeamMemberInvitationMutationFn = Apollo.MutationFunction<AcceptTeamMemberInvitationMutation, AcceptTeamMemberInvitationMutationVariables>;

/**
 * __useAcceptTeamMemberInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptTeamMemberInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTeamMemberInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTeamMemberInvitationMutation, { data, loading, error }] = useAcceptTeamMemberInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *      teamMemberId: // value for 'teamMemberId'
 *   },
 * });
 */
export function useAcceptTeamMemberInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTeamMemberInvitationMutation, AcceptTeamMemberInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTeamMemberInvitationMutation, AcceptTeamMemberInvitationMutationVariables>(AcceptTeamMemberInvitationDocument, options);
      }
export type AcceptTeamMemberInvitationMutationHookResult = ReturnType<typeof useAcceptTeamMemberInvitationMutation>;
export type AcceptTeamMemberInvitationMutationResult = Apollo.MutationResult<AcceptTeamMemberInvitationMutation>;
export type AcceptTeamMemberInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptTeamMemberInvitationMutation, AcceptTeamMemberInvitationMutationVariables>;
export const CreateTeamMemberDocument = gql`
    mutation createTeamMember($outfitterId: ID!, $data: CreateTeamMemberInput!) {
  createTeamMember(outfitterId: $outfitterId, data: $data) {
    ...TeamMemberFields
  }
}
    ${TeamMemberFieldsFragmentDoc}`;
export type CreateTeamMemberMutationFn = Apollo.MutationFunction<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;

/**
 * __useCreateTeamMemberMutation__
 *
 * To run a mutation, you first call `useCreateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMemberMutation, { data, loading, error }] = useCreateTeamMemberMutation({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>(CreateTeamMemberDocument, options);
      }
export type CreateTeamMemberMutationHookResult = ReturnType<typeof useCreateTeamMemberMutation>;
export type CreateTeamMemberMutationResult = Apollo.MutationResult<CreateTeamMemberMutation>;
export type CreateTeamMemberMutationOptions = Apollo.BaseMutationOptions<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;
export const UpdateTeamMemberDocument = gql`
    mutation updateTeamMember($id: ID!, $data: UpdateTeamMemberInput!) {
  updateTeamMember(id: $id, data: $data) {
    ...TeamMemberFields
  }
}
    ${TeamMemberFieldsFragmentDoc}`;
export type UpdateTeamMemberMutationFn = Apollo.MutationFunction<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;

/**
 * __useUpdateTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMemberMutation, { data, loading, error }] = useUpdateTeamMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>(UpdateTeamMemberDocument, options);
      }
export type UpdateTeamMemberMutationHookResult = ReturnType<typeof useUpdateTeamMemberMutation>;
export type UpdateTeamMemberMutationResult = Apollo.MutationResult<UpdateTeamMemberMutation>;
export type UpdateTeamMemberMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;
export const DeleteTeamMemberDocument = gql`
    mutation deleteTeamMember($id: ID!) {
  deleteTeamMember(id: $id)
}
    `;
export type DeleteTeamMemberMutationFn = Apollo.MutationFunction<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;

/**
 * __useDeleteTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMemberMutation, { data, loading, error }] = useDeleteTeamMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>(DeleteTeamMemberDocument, options);
      }
export type DeleteTeamMemberMutationHookResult = ReturnType<typeof useDeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationResult = Apollo.MutationResult<DeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;
export const SendTeamMemberInviteDocument = gql`
    mutation sendTeamMemberInvite($id: ID!) {
  sendTeamMemberInvite(id: $id)
}
    `;
export type SendTeamMemberInviteMutationFn = Apollo.MutationFunction<SendTeamMemberInviteMutation, SendTeamMemberInviteMutationVariables>;

/**
 * __useSendTeamMemberInviteMutation__
 *
 * To run a mutation, you first call `useSendTeamMemberInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTeamMemberInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTeamMemberInviteMutation, { data, loading, error }] = useSendTeamMemberInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendTeamMemberInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendTeamMemberInviteMutation, SendTeamMemberInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTeamMemberInviteMutation, SendTeamMemberInviteMutationVariables>(SendTeamMemberInviteDocument, options);
      }
export type SendTeamMemberInviteMutationHookResult = ReturnType<typeof useSendTeamMemberInviteMutation>;
export type SendTeamMemberInviteMutationResult = Apollo.MutationResult<SendTeamMemberInviteMutation>;
export type SendTeamMemberInviteMutationOptions = Apollo.BaseMutationOptions<SendTeamMemberInviteMutation, SendTeamMemberInviteMutationVariables>;